import { Game } from '@/types'
import GameCard from '../game-card'
import './game-list.scss'

export default function GameList({ games }: { games: Game[] }) {
  return (
    <div className='game-list'>
      {games.map((game, index) => (
        <GameCard key={index} game={game} />
      ))}
    </div>
  )
}
